export default "__VITE_PUBLIC_ASSET__c91503e6__"